export default __webpack_public_path__ + "static/unreal_workflow-8c24ac6e7ec7c7140466a0fc1497650c.webp";